export default __webpack_public_path__ + "img/email-icon.svg";